import { withInstall } from "../utils/index.mjs";
import _Empty from "./Empty.mjs";
const Empty = withInstall(_Empty);
var stdin_default = Empty;
import { emptyProps } from "./Empty.mjs";
export {
  Empty,
  stdin_default as default,
  emptyProps
};
